"use strict";

/**
 * This gets the full url with site path for content strings that don't include the site path.
 * @param {string} siteUrl
 * @param {string} url
 * @returns {string} full/usable url
 */
function getFullUrl(siteUrl, url) {
  if (url) {
    return url.startsWith("/") ? `${siteUrl}${url}` : url;
  }
  return "";
}

/**
 * Appends ".html" to a string only if it doesn't start with "http" or is "#" or
 * already has a video or img extention
 * @param {String} url Any url
 */
function getUrlWithExtention(url) {
  const videoExt = ["mov", "avi", "wmv", "flv", "3gp", "mp4", "mpg", "webm"];
  const imageExt = ["jpg", "jpeg", "png", "gif", "tiff"];

  if (
    url &&
    url !== "#" &&
    !url.startsWith("http") &&
    !url.includes(".html") &&
    !url.startsWith("javascript") &&
    ![...videoExt, ...imageExt].some((ext) => url.endsWith(`.${ext}`))
  ) {
    return url + ".html";
  } else {
    return url;
  }
}

module.exports = {
  getFullUrl,
  getUrlWithExtention
};
